<template>
    <div class="qxlTd" style="width: 1100px;">
        <tr height="20" style='height:30.00pt;'>
        </tr>
        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qxl65" height="26.67" width="425" colspan="3"
                style='height:20.00pt;width:318.75pt;border-right:none;border-bottom:none;' x:str>学生姓名:{{stuName}}</td>
            <td class="qxl66" width="991" style='width:743.25pt;' x:str>班级名称:{{classData.comboName}}</td>
        </tr>
        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qxl67" height="53.33" rowspan="2"
                style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 40px;'
                x:str>序号
            </td>
            <td class="qxl68" colspan="2" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评价标准</td>
            <td class="qxl69" :colspan="tableData.length" x:str>教师姓名(课程)</td>
            <td class="qxl74"></td>
        </tr>

        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <template v-for="(item,index) in tableData">
                <td class="qxl70" x:str>{{item[0].teaName}}
                    <font class="font0"><br /></font>
                    <font class="font0">({{ parseCourseName(item[0].courseName) }})</font>
                </td>
            </template>
            <td class="qxl74"></td>
        </tr>

        <template v-for="(item,row) in tableData[0]">
            <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
                <td class="qxl71" height="53.33" style='height:40.00pt;' x:num>{{item.xh}}</td>
                <td class="qxl72" colspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:1.0pt solid windowtext;' x:str>
                    {{item.pjxnr}}
                </td>
                <template v-for="(itemB,column) in tableData">
                    <td class="qxl73" x:str>
                        {{tableData[column][row].df}}
                    </td>
                </template>
                <td class="qxl74"></td>
            </tr>
        </template>

        <tr height="20" style='height:30.00pt;'>
        </tr>
    </div>
</template>

<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";

    export default {
        props: ['tableData', 'stuName', 'stuCode'],
        data() {
            return {
                classData: []
            };
        },
        mounted() {
            this.className();
        },
        methods: {
            parseCourseName(str){
                let split = str.split("、");
                let set = new Set();
                split.forEach(item=>{
                    set.add(item)
                })
                str = "";
                set.forEach(item=>{
                    str += item + "、"
                })
                return str.substring(0, str.length - 1);
            },
            className() {
                this.$api.evaluateManage.questionnaireServer.class({
                        data: this.stuCode
                    })
                    .then((res) => {
                        this.classData = res.data.data
                    }).catch((err) => {
                        console.log(err);
                    });
            }
        },
    };
</script>

<style>
    /* 教师教学质量评价（学生） start */

    .font0 {
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: "宋体";
        mso-generic-font-family: auto;
        mso-font-charset: 134;
    }

    .styleStu {
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
        mso-style-name: "常规";
        mso-style-id: 0;
    }

    .qxlTd {
        mso-style-parent: styleStu;
        padding-top: 1px;
        padding-right: 1px;
        padding-left: 1px;
        mso-ignore: padding;
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;

        overflow: auto;
        width: 100%;
    }

    .qxl65 {
        mso-style-parent: styleStu;
        text-align: left;
        font-weight: 700;
        mso-font-charset: 134;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .qxl66 {
        mso-style-parent: styleStu;
        font-weight: 700;
        mso-font-charset: 134;

        position: sticky;
        left: 340px;
        background-color: #ffffff;

    }

    .qxl67 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .qxl68 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 40px;
        background-color: #ffffff;
    }

    .qxl69 {
        mso-style-parent: styleStu;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qxl70 {
        mso-style-parent: styleStu;
        text-align: center;

        /* ------------ */
        white-space: normal;
        min-width: 140px;
        /* ------------ */

        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qxl71 {
        mso-style-parent: styleStu;
        text-align: center;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .qxl72 {
        mso-style-parent: styleStu;
        text-align: left;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        max-width: 300px;
        min-width: 300px;
        white-space: normal;

        position: sticky;
        left: 40px;
        background-color: #ffffff;
    }

    .qxl73 {
        mso-style-parent: styleStu;
        text-align: center;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
    }

    .qxl74 {
        border-left: .5pt solid windowtext;

        position: sticky;
        right: -1px;
        background-color: #ffffff;
    }

/*    .sticky-table {
        overflow: auto;
        width: 100%;
    } */

    /* 教师教学质量评价（学生） end */
</style>



// WEBPACK FOOTER //
// queryStuEvaluate.vue?986bf8ae